import React from 'react';
import Grid from '@mui/material/Grid';
import AutoSelect from '../../../containers/selects/auto_select';

const AutoSelectClient = (props) => {

    return(
        <Grid container spacing={1}>
            <Grid item xs={12} md={12}>
                <AutoSelect
                    id='order_client'
                    label='Cliente'
                    getOptionLabel={(option) => `${option.name} - ${option.identification}`}
                    renderOption={(props, option) => (<div {...props}>{`${option.name} - ${option.identification}`}</div>)}
                    data={props.clients}
                    // value={props.clients.length > 0 ? props.clients[0] : null}
                />
            </Grid>
        </Grid>
    );

}

export default AutoSelectClient;